import { APP_URL } from "utils/constants";
import { httpClient } from "utils/axios";

export class IUMSService {
  constructor(clientSide = true) {
    this.clientSide = clientSide;
  }
  getGroupDetails = (id) => {
    return httpClient.get(
      `${this.clientSide ? "" : APP_URL}/api/iums/groups/${id}`
    );
  };

  getGroupThesis = (id) => {
    return httpClient.get(
      `${this.clientSide ? "" : APP_URL}/api/iums/thesis/${id}`
    );
  };

  getAllEdmEducationalTerm = async () => {
    return httpClient.get(
      `${this.clientSide ? "" : APP_URL}/api/iums/terms`
    );
}

getEducationalCalendarByTermId = async (termId: number) => {
  return httpClient.get(
    `${this.clientSide ? "" : APP_URL}/api/iums/calendar/${termId}`
  );
}
}

export const iumsService = new IUMSService();
